import React from 'react'
import { Segmented, Tabs } from 'antd'
import { ISettingsNavGroup, ISettingsPage } from './registry'

interface ISettingsNarrowNav<C> {
    groups: ISettingsNavGroup<C>[]
    page: ISettingsPage<C>
    onNavigate: (key: string) => void
}

/** The same registry as the rail, for a narrow content area: a tab per group, then that group's pages. */
export const SettingsNarrowNav = <C,>({ groups, page, onNavigate }: ISettingsNarrowNav<C>) => {
    const active = groups.find((g) => g.key === page.group) ?? groups[0]

    return (
        <div className="settings-narrow-nav">
            {/* One group needs no tab to choose it. */}
            {groups.length > 1 && (
                <Tabs
                    size="small"
                    animated={false}
                    activeKey={active?.key}
                    onChange={(groupKey) => {
                        const group = groups.find((g) => g.key === groupKey)
                        if (group) onNavigate(group.pages[0].key)
                    }}
                    items={groups.map((g) => ({ key: g.key, label: g.label }))}
                />
            )}
            {active && active.pages.length > 1 && (
                <Segmented
                    block
                    value={page.key}
                    onChange={(key) => onNavigate(key as string)}
                    options={active.pages.map((p) => ({ value: p.key, label: p.label }))}
                />
            )}
        </div>
    )
}
